import { RouteObject } from "react-router-dom";
import { DevelopmentSettingsPage } from "src/routes/developments/settings/DevelopmentSettingsPage";
import * as settingsPaths from "src/routing/domains/developments/settings/settingsPaths";

/**
 * SideNav leaf routes for development settings section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in `detail/developmentDetail.tsx`.
 */
export const settingsSideNavRoutes: RouteObject[] = [
  { path: settingsPaths.developmentSettingsRoute.path, Component: DevelopmentSettingsPage },
];
